var img_url1 = "/official/images/pc/l-logo-c4c24e68f3.png";
var img_url2 = "/official/images/pc/r-logo-eb27ec90a7.png";
var img_url3 =
  "https://download4.qcplay.com/qcgame-admin/iLDZRtXHF7xLBetGTDABzpPhszVonb93rY3mPyaP.png";
var img_url4 =
  "https://download4.qcplay.com/qcgame-admin/qgLjdGyMFCovN7eZKn5TrB8ivpvlRUdIvd2wXmO8.png";

// pc端
var footerHtml =
  '<div class="footer-content">' +
  '<div class="l-logo"><img src=' +
  img_url1 +
  "></div>" +
  '<div class="content">' +
  "<p>" +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/secrecy_web.html">CHÍNH SÁCH BẢO MẬT</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/service_agreement_web.html">ĐIỀU KHOẢN, ĐIỀU KIỆN SỬ DỤNG DỊCH VỤ</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/session_management_instructions.html">QUẢN LÝ HỘI THOẠI</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/compensation_complaint_process.html">GIẢI QUYẾT TRANH CHẤP </a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/privacy_policy_web.html">CHÍNH SÁCH BẢO VỆ DỮ LIỆU CÁ NHÂN </a></p>' +
  "<p>Hotline: 0878099678</p>" +
  "<p>Email: support@visionnetwork.vn</p>" +
  "<p>Bản quyền © 2024 .VISION NETWORK</p>" +
  "<p>Thời gian: 8:00 - 22:00 tất cả các ngày (GMT+7)</p>" +
  "<p>Chơi quá 180 phút một ngày sẽ ảnh hưởng xấu đến sức khỏe</p>" +
  "<p>QĐ số:510/QĐ-PTTH&TTĐT ngày 14/08 /2026</p>" +
  "<p>Người chịu trách nhiệm nội dung: Phạm Quang Minh</p>" +
  "<p>Công ty Cổ phần Giải pháp số Vision Network Việt Nam, Tầng 6, số 18 Nguyễn Chí Thanh, phường Giảng Võ, TP Hà Nội.</p>" +
  "<p>Mã số đăng ký doanh nghiệp: 0105661487</p>" +
  "</div>" +
  '<div class="r-logo"></div>' +
  "</div>";
$(".footer").append(footerHtml);

// 移动端
var mFooterHtml =
  '<div class="footer-content">' +
  '<div class="l-logo"><img src=' +
  img_url1 +
  "></div>" +
  '<div class="content">' +
  "<p>" +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/secrecy_web.html">CHÍNH SÁCH BẢO MẬT</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/service_agreement_web.html ">ĐIỀU KHOẢN, ĐIỀU KIỆN SỬ DỤNG DỊCH VỤ</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/session_management_instructions.html">QUẢN LÝ HỘI THOẠI</a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/compensation_complaint_process.html ">GIẢI QUYẾT TRANH CHẤP </a>&nbsp;&nbsp;|&nbsp;&nbsp;' +
  '<a target="_blank" href="https://law.supersnail.vn/vi-vn/privacy_policy_web.html">CHÍNH SÁCH BẢO VỆ DỮ LIỆU CÁ NHÂN </a></p>' +
  "<p>Hotline: 0878099678</p>" +
  "<p>Email: support@visionnetwork.vn</p>" +
  "<p>Bản quyền © 2024 .VISION NETWORK</p>" +
  "<p>Thời gian: 8:00 - 22:00 tất cả các ngày (GMT+7)</p>" +
  "<p>Chơi quá 180 phút một ngày sẽ ảnh hưởng xấu đến sức khỏe</p>" +
  "<p>QĐ số:510/QĐ-PTTH&TTĐT ngày 14/08 /2026</p>" +
  "<p>Người chịu trách nhiệm nội dung: Phạm Quang Minh</p>" +
  "<p>Công ty Cổ phần Giải pháp số Vision Network Việt Nam, Tầng 6, số 18 Nguyễn Chí Thanh, phường Giảng Võ, TP Hà Nội.</p>" +
  "<p>Mã số đăng ký doanh nghiệp: 0105661487</p>" +
  "</div>" +
  // '<div class="r-logo"><img src=' +
  // img_url2 +
  // "></div>" +
  "</div>";
$(".m-footer").append(mFooterHtml);
